import { render, staticRenderFns } from "./sendCodeForm.vue?vue&type=template&id=40ab7186"
import script from "./sendCodeForm.vue?vue&type=script&lang=js"
export * from "./sendCodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports